import React from "react";
import { Accordion, AccordionItem } from "@heroui/react";
import { Plus } from "lucide-react";

import faqs from "./faqs";

export default function FAQSection() {
  return (
    <section id="faq" className="mx-auto w-full max-w-6xl py-20 sm:px-6 sm:py-32 lg:px-8 lg:py-40">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-6 lg:flex-row lg:items-start lg:gap-12">
        <h2 className="text-foreground px-2 text-2xl leading-7 sm:text-3xl lg:text-5xl lg:font-semibold lg:tracking-tight">
          <span className="inline-block lg:hidden">FAQs</span>
          <span className="hidden pt-4 lg:inline-block">
            常见问题FAQ
            <br />
          </span>
        </h2>
        <Accordion
          fullWidth
          keepContentMounted
          className="gap-3"
          itemClasses={{
            base: "px-0 sm:px-6",
            title: "font-medium",
            trigger: "py-6 flex-row-reverse",
            content: "pt-0 pb-6 text-base text-default-500",
          }}
          items={faqs}
          selectionMode="multiple"
        >
          {faqs.map((item, i) => (
            <AccordionItem key={i} indicator={<Plus className="h-6 w-6" />} title={item.title}>
              <span className="whitespace-pre-line">{item.content}</span>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
